
// initial state
const state = {
    token: null,
};

// getters
const getters = {
    getToken: (state) => {
        return state.token;
    },
};

// mutations
const mutations = {
    setToken: (state, value) => {
        state.token = `Bearer ${value}`;
    },
};
// actions
const actions = {
    callSetToken: (context, value) => {
        context.commit('setToken', value);
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
